<template>
  <div class="analyze">
    <div style="height: 100%;width: 100%">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane v-for="(item,index) in tabsData" :key="index" :label="item.label" :name="item.name">
        </el-tab-pane>
      </el-tabs>
      <div class="outAnalyze">
        <div class="outBox"   v-if="btomList.length != 0">
          <div class="y_axis">
            <div class="y_label" v-for="(i,x) in yLabelList" :key=x :class="i == 0? 'low':''">{{i}}</div>
            <div class="outBoxs">
              <div class="green" style="background-color: #82D237"></div>
            </div>
            <div class="outBoxs">
              <div class="green" style="background-color: #E95646"></div>
            </div>
            </div>
          <div class="outBigBox" v-loading="analyzeLoading">
            <div class="topX">
              <div class="node" v-for="(i,x) in xaxisList" :key="x">
                <div class="out">
                  <el-tooltip placement="right" effect="light">
                    <div slot="content" class="content">
                      <div class="inTop">
                        <div style="font-weight: normal">{{i.title}}</div>
                        <div style="font-weight: normal;">{{i.succ + i.fail}} <span style="font-weight: normal;">Tasks</span></div>
                      </div>
                      <div class="inBtom">
                        <div class="inner">
                          <div> <div style="background-color: #82D237" class="littleBox"></div> Succeeded</div>
                          <div>{{i.succ}} <span style="font-weight: normal">Tasks</span></div>
                        </div>
                        <div class="inner">
                          <div><div style="background-color: #E95646" class="littleBox"></div> Failed</div>
                          <div>{{i.fail}} <span style="font-weight: normal">Tasks</span></div>
                         </div>
                      </div>
                    </div>
                    <div class="inner" :style="{height:i.sumHeight}">
                      <!--                绿色柱子-->
                      <div :style="{height:i.greenHeight}" style="background-color: #82D237" class="red"></div>
                      <!--                红色柱子-->
                      <div :style="{height: i.redHeight}" style="background-color: #E95646" class="red"></div>
                    </div>
                  </el-tooltip>
                </div>
              </div>
            </div>
              <div class="outBtom">
                  <div class="btomX" v-for="(item,index) in btomList" :key="index">
                    <div style="margin-bottom: 8px" class="btomWord">{{item.word}}</div>
                    <div style="margin-bottom: 4px">{{item.success_count}}</div>
                    <div>{{item.fail_count}}</div>
                  </div>
              </div>
          </div>

        </div>
        <div v-else class="empty">
          <div>
            <img src="../assets/image/list_blank.png" alt="">
            <h2 style="color: #CCCCCC;font-size: 16px;text-align: center">No data</h2>
          </div>
        </div>
          <div class="warpper"></div>
<!--        中间分割线-->
        <div class="middleLine"></div>
<!--        右边选择下拉框-->
        <div class="rightBox">
          <!-- Group -->
          <div class="innerSelect" v-if="userInfo.type !=1">
            <span class="spanWith">Group</span>
            <el-select v-model="groupValue" placeholder="" @change="changeGroup">
              <el-option
                v-for="item in groupOption"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </div>
           <!--Organization  -->
           <div class="innerSelect">
            <span>Organization</span>
            <el-select v-model="organiValue" placeholder="" @change="changeOrganiSelect" :disabled="userInfo.type !=1 ? false :true">
              <el-option
                v-for="item in organiOption"
                :key="item.id"
                :label="item.organization_name"
                :value="item.id">
              </el-option>
            </el-select>
          </div>

           <!-- Store -->
           <div class="innerSelect">
            <span class="spanWith">Store</span>
            <el-select v-model="storeValue" placeholder="" @change="changeStoreSelect" :disabled="userInfo.type !=1 ? false :true">
              <el-option
                v-for="item in storeOption"
                :key="item.id"
                :label="item.store_name"
                :value="item.id">
              </el-option>
            </el-select>
          </div>


           <!-- Range -->
          <div class="innerSelect">
            <span class="spanWith">Range</span>
            <el-select v-model="rangeSelect" placeholder="" @change="changeRangeSelect">
              <el-option
                v-for="item in rangeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>

          <div class="innerSelect time" v-if="rangeSelect == '4'">
            <div class="inFrom">from</div>
            <el-date-picker
              v-model="time1"
              type="date"
              :clearable="false"
              placeholder="No date selected"
              value-format="yyyy-MM-dd HH:mm:ss"
              @change="chooseDate"
            >
            </el-date-picker>
          </div>
          <div class="innerSelect time" v-if="rangeSelect == '4'">
            <div class="inFrom">to</div>
            <el-date-picker
              v-model="time2"
              type="date"
              :clearable="false"
              placeholder="No date selected"
              value-format="yyyy-MM-dd HH:mm:ss"
              @change="chooseDate"
            >
            </el-date-picker>
          </div>
          <!-- Driver type -->
          <div class="innerSelect">
            <!-- <span style="width: 55px;">Tag</span> -->
            <span class="spanWith">Driver type</span>

            <el-select v-model="tagValue" placeholder="" @change="changeTag" :disabled="userInfo.type !=1 ? false :true">
              <el-option
                v-for="item in tagOption"
                :key="item.id"
                :label="item.tag_name"
                :value="item.id">
              </el-option>
            </el-select>
          </div>
          <!-- Driver -->
          <div class="innerSelect">
            <span class="spanWith">Driver</span>
            <el-select v-model="driverValue" placeholder="" @change="changeDriver">
              <el-option
                v-for="item in driverOption"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </div>
          <div class="down_bton" @click="downLoadHandle">
            Download
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getDriverList,getDriverListChart} from "@/api/tasks";
import {getGroupList,workerTagList,workerTagList2} from "@/api/driver";
import {exportAnylaze, getAnalyze} from "@/api/analyze";

import {getOraList, getStoreList} from "@/api/organization";

export default {
  name: "analyze",
  data(){
    return{
      activeName:'1',
      tabsData:[
        {name:"1",label:'Time(Day)'},
        {name:"2",label:'Time(Week)'},
        {name:"3",label:'Time(Month)'},
        {name:"4",label:'Day of week'},
        {name:"5",label:'Hour of day'},
        {name:"6",label:'Drivers'},
      ],
     rangeSelect:"1",
      rangeOptions:[
        {label:'Last 24 hours',value:"1",},
        {label:'Last week',value:"2",},
        {label:'Last 30 days',value:"3",},
        {label:'Custom…',value:"4",},
      ],
      groupValue:'loading...',
      groupOption:[],
      driverValue:'loading...',
      driverOption:[],
      tagValue:'loading...',
      tagOption:[],

      organiValue:'loading...',
      organiOption:[],
      storeValue:'loading...',
      storeOption:[],

      time1:"",
      time2:'',
      yaxis:'',
      yLabelList:[],
      xaxisList:[],
      btomList:[],
      heightList:[],
      start_time:"",
      end_time:'',
      type:'',
      group_id:"",
      worker_id:"",
      analyzeLoading:false,

      userInfo:{},
    }
  },
   async created() {
    this.userInfo = JSON.parse(localStorage.getItem('userInfoDetail'))
    console.log('--登录用户信息---',this.userInfo)

    if (this.userInfo.organization_id !=null) {
      //this.organiValue = this.userInfo.organization_id
    }

    // 获取gtoup driver 列表 联动
    this.getOutGroup()

    // this.getOutDriver()
    this.getTagsListOptionData()

    //获取组织
    const res = await getOraList({ page: 1, limit: '' });
    if (res.code === 200) {
      if (this.userInfo.type !== 1) {
        this.organiValue = 0;
        this.organiOption = res.data.data;
        this.organiOption.unshift({
          id: 0,
          organization_name: 'All organizations'
        });
      } else {
        const array = res.data.data;
        for (let index = 0; index < array.length; index++) {
          const element = array[index];
          if (this.userInfo.organization_id === element.id) {
            this.organiOption.unshift({
              id: element.id,
              organization_name: element.organization_name
            });
            this.organiValue = this.userInfo.organization_id;
          }
        }
      }
    }
     if (this.rangeSelect == 1){
       //过去24小时
       let t1, t2 = 0;
       t1= new Date();
       t2 = t1 - 24*1000*60*60
       this.end_time = this.getTime(t1)
       this.start_time = this.getTime(t2)
     }else if (this.rangeSelect == 2){
       //过去一周
       const d1 = new Date(),d2 = new Date();
       let t1, t2 = 0;
       t1 = new Date(d1.setDate(d1.getDate() - 7)).setHours(0, 0, 0, 0);
       t2 = new Date(d2.setDate(d2.getDate())).setHours(0, 0, 0, 0);
       this.start_time = this.getTime(t1)
       this.end_time = this.getTime(t2)
     }else if (this.rangeSelect == 3){
       //过去30天
       const d1 = new Date(), d2 = new Date();
       let t1 = 0, t2 = 0
       t1 = new Date(d1.setDate(d1.getDate() - 30)).setHours(0, 0, 0, 0);
       t2 = new Date(d2.setDate(d2.getDate())).setHours(0, 0, 0, 0);
       this.start_time = this.getTime(t1)
       this.end_time = this.getTime(t2)
     }
    await this.getStorelistOptionData();
  },
  methods:{
    //下载
    downLoadHandle(){
      exportAnylaze({
        start_time:this.start_time,
        end_time:this.end_time,
        type:this.activeName,
        group_id:this.groupValue,
        worker_id:this.driverValue,
        tag_id:this.tagValue,
        organization_id:this.organiValue,
        store_id:this.storeValue
      }).then(res=>{
        this.download(res.data.file)
      })
    },
    download(url){
      const link = document.createElement('a')
      link.href = 'https://work.back.rapidi.ca/storage/' + url
      link.setAttribute('download', '文件名字' + Date.now() + '.xls') // 下载文件的名称及文件类型后缀
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link) // 下载完成移除元素
    },
    //组织下拉
    async getOrainListOptionData() {
      try {
        const res = await getOraList({ page: 1, limit: '' });
        if (res.code === 200) {
          if (this.userInfo.type !== 1) {
            this.organiValue = 0;
            this.organiOption = res.data.data;
            this.organiOption.unshift({
              id: 0,
              organization_name: 'All organizations'
            });
          } else {
            const array = res.data.data;
            for (let index = 0; index < array.length; index++) {
              const element = array[index];
              if (this.userInfo.organization_id === element.id) {
                this.organiOption.unshift({
                  id: element.id,
                  organization_name: element.organization_name
                });
                this.organiValue = this.userInfo.organization_id;
              }
            }
          }
          await this.getStorelistOptionData();
        }
      } catch (error) {
        console.error('Error occurred while fetching organization list:', error);
      }
    },
    //门店下拉
    async getStorelistOptionData(){
        this.storeOption = []
       await getStoreList({
          page:1,
          id:this.organiValue,
        }).then(res=>{
          if(res.code == 200){

            if(this.userInfo.type !=1){
              this.storeValue = 0
              this.storeOption = res.data.data
              this.storeOption.unshift({
                id:0,
                store_name:'All stores'
              })
            }else{
              let array = res.data.data
              for (let index = 0; index < array.length; index++) {
                const element = array[index];
                if (element.id == this.userInfo.id) {
                  this.storeOption.unshift({
                    id:element.id,
                    store_name:element.sub_organization_name
                  })
                  this.storeValue = this.userInfo.id
                }
              }
              console.log('这里看看')
            }

          }else{
            //临时 2023年9月26日
            this.storeValue = 0
            this.storeOption.unshift({
              id:0,
              store_name:'All stores'
            })
          }
         this.getChangeData()
       })
    },




    getTime(timdedetail){
    //获取年份
    var year=new Date(timdedetail).getFullYear();
    //获取月份，获取的月份比实际小1，所以在使用的时候需要+1
    var month=new Date(timdedetail).getMonth()+1;
    //获取日
    var date=new Date(timdedetail).getDate();
    //获取时
    // var hours=new Date(timdedetail).getHours();
    //获取分
    // var minutes=new Date(timdedetail).getMinutes();
    //获取秒
    // var seconds=new Date(timdedetail).getSeconds();
    //组合格式为年-月-日 时：分：秒（2021-7-5 21:21:21）
     var time=year+"-"+month+"-"+date
      return  time;
    },
    changeRange(){
      if (this.rangeSelect == 1){
        //过去24小时
        let t1, t2 = 0;
          t1= new Date();
          t2 = t1 - 24*1000*60*60
        this.end_time = this.getTime(t1)
        this.start_time = this.getTime(t2)
      }else if (this.rangeSelect == 2){
        //过去一周
        const d1 = new Date(),d2 = new Date();
        let t1, t2 = 0;
        t1 = new Date(d1.setDate(d1.getDate() - 7)).setHours(0, 0, 0, 0);
        t2 = new Date(d2.setDate(d2.getDate())).setHours(0, 0, 0, 0);
        this.start_time = this.getTime(t1)
        this.end_time = this.getTime(t2)
      }else if (this.rangeSelect == 3){
        //过去30天
        const d1 = new Date(), d2 = new Date();
        let t1 = 0, t2 = 0
        t1 = new Date(d1.setDate(d1.getDate() - 30)).setHours(0, 0, 0, 0);
        t2 = new Date(d2.setDate(d2.getDate())).setHours(0, 0, 0, 0);
        this.start_time = this.getTime(t1)
        this.end_time = this.getTime(t2)
      }
      console.log('这个')
      this.getChangeData()
      this.getOutDriver()
    },
    getXaxisItem(){
      //将返回的数组从新调整  success+fail 重组一个数组 找出数组的最大值 为柱状图的最长的高度
      let maxArr = []
      this.heightList = []
      this.xaxisList = []
      this.btomList.forEach(item=>{
        let a = item.success_count + item.fail_count
      //这是高度和
        maxArr.push(a)
        this.heightList.push({
          sumHeight:a,
          greenHeight:item.success_count,
          redHeight:item.fail_count,
          title:item.word
        })
      })
      this.heightList.forEach(item=>{
        let max = Math.max(...maxArr)
        let sum = (item.sumHeight*100/max).toFixed(2)
        let green = (item.greenHeight*100/item.sumHeight).toFixed(2)
        let red = (item.redHeight*100/item.sumHeight).toFixed(2)
        //这是高度和 的百分比
        this.xaxisList.push({
          sumHeight:sum+'%',
          greenHeight:green+'%',
          redHeight:red+'%',
          succ:item.greenHeight,
          fail:item.redHeight,
          title:item.title
        })
      })
    },
    getYaxis(){
      //获取最大值之后讲 y 等分成10分
      let x = this.yaxis/10
      this.yLabelList = []
      for (let i = 0;i<=10; i++){
        let a = x*i
        this.yLabelList.push(a.toFixed())
      }
      this.yLabelList = this.yLabelList.reverse()
    },
    //获取Group下拉数据
   async getOutGroup(){
     await getGroupList({
        order:'time desc',
        page:1,
        limit:''
      }).then(res=> {
        if (res.code == 200){
          this.groupOption = res.data.data
          this.groupOption.unshift({
            name:'All groups',
            id:0
          })
          this.groupValue = 0
          // this.getOutDriver(this.groupValue)
          // this.getTagsListOptionData()
        }else {
          this.groupOption = []
          this.$message({
            message: res.msg,
            type: 'warning'
          });
        }
      }).catch(err=>{
        this.$message({
          message: err.msg,
          type: 'error'
        });

      })
    },
    //获取司机下拉列表选择项
    getOutDriver(){
       getDriverListChart({
        group_id:this.groupValue == 'loading...'? 0 :this.groupValue,
        start_time:this.start_time,
        end_time:this.end_time,
        tag_id: this.tagValue == 'loading...' ? 0 :this.tagValue
      }).then(res=>{
        this.driverValue = 0
        this.driverOption = res.data
        this.driverOption.unshift({
          id:0,
          name:'All drivers'
        })
      })
    },
    //获取tag标签下拉列表选择项
    getTagsListOptionData(){
        // workerTagList({
        // page: 1,
        // // limit:0
        //   }).then((res) => {
        //     this.tagValue = 0
        //     this.tagOption = res.data.data
        //     this.tagOption.unshift({
        //       id:0,
        //       // tag_name:'All tags'
        //       tag_name:'All driver types'
        //     })
        // });

        workerTagList2({
          page: 1,
          limit:''
        }).then((res) => {
            // console.log('--driver type--',res)
            if(this.userInfo.type !=1){
              this.tagValue = 0
              this.tagOption = res.data
              this.tagOption.unshift({
                id:0,
                tag_name:'All driver types'
              })
            }else{
              let array = res.data
              for (let index = 0; index < array.length; index++) {
                const element = array[index];
                if(element.id == 2){
                  this.tagOption.unshift({
                    id:element.id,
                    tag_name:element.tag_name
                  })
                  this.tagValue = element.id
                }
              }
            }

            this.getOutDriver()

        });
    },

    handleClick(val){
      this.activeName = val.name
      this.getChangeData()
    },
     changeGroup(){
      this.getOutDriver()
      this.driverValue = 0
      this.getChangeData()
    },

    changeOrganiSelect(){
      console.log('-选择组织--')
      this.getStorelistOptionData()
      this.getChangeData()
    },
    changeStoreSelect(){
      console.log('--选择store--')
      this.getChangeData()
    },


    changeRangeSelect(a){
      if (a<4){
        this.changeRange()
      }
    },
    changeDriver(){
      this.getChangeData()
    },
    changeTag(){
      this.getChangeData()
      this.getOutDriver()
    },
    getChangeData(){
      this.analyzeLoading = true
      let value1 = ''
      let value2 = ""
      let value3 = ''
      let value4 = ''
      let value5 = ''

      if (this.groupValue == 'loading...'){
        value1 = 0
      }else {
        value1 = this.groupValue
      }
      if(this.driverValue == 'loading...'){
        value2 = 0
      }else {
       value2 = this.driverValue
      }
      if(this.tagValue == 'loading...'){
        value3  = 0
      }else{
        value3 = this.tagValue
      }
      if (this.organiValue == 'loading...') {
        value4 = 0
      } else {
        value4 = this.organiValue
      }
      if (this.storeValue == 'loading...') {
        value5 = 0
      } else {
        value5 = this.storeValue
      }
      getAnalyze({
        start_time:this.start_time,
        end_time:this.end_time,
        type:this.activeName,
        group_id:value1,
        worker_id:value2,
        tag_id:value3,
        organization_id:value4,
        store_id:value5
      }).then(res=>{
        this.analyzeLoading = false
        if (res.code == 200){
          this.btomList = res.data
          let big = []
          this.btomList.forEach(i=>{
            big.push(i.success_count + i.fail_count)
          })
          this.yaxis = Math.max.apply(null, big);
          this.getXaxisItem()
          this.getYaxis()
        }else {
          this.$message({
            type:'warning',
            message:res.msg
          })
        }
      })
    },
    chooseDate(){
      if (this.time1 != '' && this.time2 != ''){
        this.start_time = this.time1
        this.end_time = this.time2
        this.getChangeData()
        this.getOutDriver()
      }
    }
  },
}
</script>

<style scoped lang="less">

.spanWith{
  width: 133px;
  text-align: right;
}
.analyze{
  width: 100%;
  height: 100%;
  /deep/.el-tabs__header{
    margin: 0;
  }
  .outAnalyze{
    display: flex;
    //width: 100%;
    height: 90%;
    .outBox{
      width: 90%;
      height:100%;
      padding-top: 32px;
      display: flex;
      .y_axis{
        width: 80px;
        border-right: 1px solid #E0E0E0;
        height: 100%;
        font-size: 14px;
        margin-right: 9px;
        .low{
          margin-bottom: -12px;
        }
        .y_label{
          height: 8%;
          font-weight: normal;
          text-align: right;
          padding-right: 8px;
        }
        .outBoxs{
          text-align: right;
          .green{
            display: inline-block;
            margin: 8px;
            width: 16px;
            height: 16px;
          }
        }
      }
      .outBigBox{
        //style="position: relative;width: 100%;height: 100%"
        position: relative;
        width: 100%;
        height: 100%;
        overflow: auto;
        .topX{
          height: 80%;
          display: flex;
          position: absolute;
          top: 0;
          .node{
            width: 60px;
            height: 100%;
            padding: 0 15px;
            .out{
              width: 100%;
              height: 100%;
              display: flex;
              .inner{
                width: 100%;
                border-radius: 5px;
                overflow: hidden;
                align-self: flex-end;
                .red{
                  width: 100%;
                }
              }

            }
          }
        }
        .outBtom{
          display: flex;
          position: absolute;
          bottom: 0;
          left: 0;
          height: 20%;
          font-size: 14px;
          .btomX{
            font-weight: normal;
            //height: 100px;
            width: 90px;
            line-height: 32px;
            flex-shrink: 0;
          }
          .btomWord{
            height: 32px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
      }

    }
    .empty{
      width: 200px;
      margin: 20px auto;
      text-align: center;
      position: relative;
      div{
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
      }
      h2{
        font-size: 16px;
      }
      img{
        width: 100%;
        height: 200px;
        margin: 0;
      }
    }
    .middleLine{
      width: 1px;
      height: 106%;
      background: #E0E0E0;
    }
    .rightBox{
      width: 360px;
      height: 80%;
      //border-left: 1px solid #E0E0E0;
      .innerSelect{
        display: flex;
        margin: 16px 0 0 16px;
        span{
          margin-right: 16px;
          font-size: 14px;
          line-height: 32px;
        }
        .inFrom{
          display: inline-block;
          margin-right: 16px;
          text-align: right;
          width: 50px;
          font-weight: normal;
        }

      }
      .down_bton{
        width: 237px;
        margin-top: 16px;
        background-color: #E95646;
        text-align: center;
        color: #FFFFFF;
        line-height: 32px;
        font-size: 14px;
        border-radius: 20px;
        cursor: pointer;
        margin-left: 124px;
      }
      .time{
        /deep/.el-input__prefix{
          position: absolute;
          top: 0;
          right: 12px;
          left: auto;
        }
        /deep/ .el-input--prefix .el-input__inner{
          padding-left: 12px;
        }
        /deep/.el-input__icon{
          //position: absolute;
          //right: 12px;
          color: #D65953;
        }

      }
    }
  }
}
.content{
  width: 220px;
  .inTop{
    display: flex;
    justify-content: space-between;
    line-height: 20px;
    border-bottom:  2px solid #E0E0E0;
    padding-bottom: 12px;
  }
  .inBtom{
    padding-top: 4px;

    .inner{
      margin-top: 8px;
      display: flex;
      justify-content: space-between;
      .littleBox{
        transform: translateY(3px);
        display: inline-block;
        margin-right: 8px;
        width: 16px;
        height: 16px;
      }
    }
  }
}
</style>
